import { web_search_sales_group_product } from "./web_search_sales_group_product";
export class web_search_sales_group {
    public id: number;
    public name: string;
    public product_id: string;
    public products: web_search_sales_group_product[] = [];
    public sales_group_display_name: string;
    public sales_group_display_description: string;
}